import * as React from 'react';
import { ViewProp } from '..';
import { className, formatNumber } from '../../util';
import getDay from 'date-fns/getDay';
import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import sv from 'date-fns/locale/sv';

interface Props extends ViewProp {
  fridayMessage: string;
}

export function MabiRental(props: Props) {
  // const [use, setUse] = React.useState(!!props.selectedMabi);
  const { mabi, selectedShop } = props;

  if (!mabi || !selectedShop) {
    return null;
  }

  const station = mabi.stations.find(s => s.misterStation === selectedShop.id);

  if (!station || !props.selectedProducts.some(product => product.pickUpDayAfter)) {
    return null;
  }

  const vehicles = mabi.vehicles.sort((a, b) => a.sortOrder - b.sortOrder);

  const rental = !!props.selectedMabi;
  const rentalVehicle = rental
    ? props.mabi?.vehicles.find(vehicle => vehicle.artNr === props.selectedMabi)
    : null;

  const selectedDate = props.selectedDate!;
  // Checks if the date is a friday
  const pickUpFriday = selectedDate && getDay(selectedDate) === 5;
  // If the date is a friday, add three full days, otherwise add one
  const pickUpDay = pickUpFriday ? addDays(selectedDate, 3) : addDays(selectedDate, 1);

  return (
    <div className='mabi-rental-container'>
      <label className='mabi-toggler'>
        <i className='fas fa-car'></i>
        {props.texts.stepTwoRentalHeader}
        {rentalVehicle &&
          <span className='chosen-rental'>
            <strong>Vald:</strong>
            {rentalVehicle.name + ` (${rentalVehicle.price} SEK/dygn)`}
          </span>
        }
      </label>
      <div className='mabi-content'>
        <div className='mabi-content-inner'>
          <span
            className='desc'
            dangerouslySetInnerHTML={{__html: props.texts.stepTwoRentalDesc}}></span>

          <div className='mabi-station-info'>
            <div className='image'>
              <img src='/images/mabi_logo.png' />
            </div>
            <div className='info'>
              <div><strong>MABI-anläggning:</strong> {station.name}</div>
              <div><strong>Adress:</strong> {station.address}</div>
              <div><strong>Telefon:</strong> {station.phone}</div>
            </div>
          </div>

          <select onChange={e => props.setMabi(e.target.value)} defaultValue={props.selectedMabi ?? ''}>
            <option value=''>-- Ingen hyrbil vald --</option>

            {vehicles.map(vehicle =>
              <option key={vehicle.artNr} value={vehicle.artNr}>
                {vehicle.name + ' (' + formatNumber(vehicle.price) + ' SEK)'}
              </option>)}
          </select>

          {pickUpFriday && <>
            <div className='mabi-friday-notice' key={'pick-up'}>
              <div className='friday-message'
                dangerouslySetInnerHTML={{__html: props.fridayMessage}}></div>
              <strong><i className='fas fa-exclamation-circle'></i> Tid för tidigast återlämning: </strong>
              {format(pickUpDay, 'dd MMMM', {locale: sv})} från 08.00
            </div></>}

        </div>
      </div>

    </div>
  );
}
